import FileInput from './file-input.js';

export default FileInput;
